import React, { forwardRef } from 'react'
import styled from 'styled-components'
import useParallax from '../use-parallax'
import { useLocation } from 'react-router-dom'

const inheritPrimaryColor = props => props.theme.primaryColor

const cambridgeLogo = `/public/cambridgelogo.png`
const xueqingComputer = `/public/xueqing-computer.jpg`

const heroByPathname = {
  '/': xueqingComputer,
  '/team': xueqingComputer,
  '/contact': xueqingComputer,
  '/publications': xueqingComputer,
  '/blog': xueqingComputer
}

// Height is hardcoded at 500px and used elsewhere so if it changes
// here I should reflect it elsewhere
const Hero = styled(({ ...props }) => {
  // const [, setParallaxElement] = useParallax({ factor: 0.5 })
  const { pathname } = useLocation()

  return (
    <div {...props}>
      <HeroBackground ref={null /* setParallaxElement */} imgSrc={heroByPathname[pathname] || xueqingComputer} />
      <HeroForeground>
        <HeroTopBar>
          <div css='margin-right: 20px; @media only screen and (max-width: 499px) { display: none; }'>
            <img css='height: 75px;' src={cambridgeLogo} />
          </div>
          <div css='flex-grow: 1;'>
            <div css='margin-bottom: 5px;'><Emphasis>Mutagenesis in Medicine</Emphasis></div>
            Early Cancer Institute, University of Cambridge
          </div>
        </HeroTopBar>
        <div css='flex-grow: 1'></div>

      </HeroForeground>
    </div>
  )
})`
  height: 500px;
  position: relative;
`
const HeroBackground = styled(forwardRef(({ imgSrc, ...props }, ref) => {
  return (
    <div ref={ref} {...props} />
  )
}))`
  background-image: url('${p => p.imgSrc}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  top: 0px;
  right: 0px;
  left: 0px;
  height: 500px;
  z-index: -1;
  will-change: transform;
`
const HeroForeground = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  padding: 30px;
  color: white;
  background-color: rgba(30, 30, 30, 0.5);
  font-weight: 200;
  font-size: 26px;
  backdrop-filter: blur(2px) saturate(80%);
`
const HeroTopBar = styled.div`
  display: flex;
`
const Emphasis = styled.span`
  color: ${inheritPrimaryColor};
  font-weight: 400;
  font-size: 34px;
`

export default Hero